import React from 'react';
import ServerPaginatedTable from '../utils/pagination.server';
import PageEmptyContent from "../utils/page.empty-content";
import moment from "moment";
import { appHelpers } from '../../_helpers';
import InitiateIcon from 'react-icons/lib/md/add';
import ApproveIcon from 'react-icons/lib/md/done';
import RejectIcon from 'react-icons/lib/md/close';
import { appConstants } from "../../_constants";
import FileDownloadIcon from 'react-icons/lib/md/file-download';
import "./index.scss";






const DataTable = ({ data, handleStatusBD, interpretAirport,  interpretDesAirport, saveToggle, user, initiateToggle, toggle, rejectToggle, approveToggle, handleDepBD, handleDesBD, handleAirlineBD, pageIndex }) => {
    const nairaCurrency =  String.fromCharCode(appHelpers.getCurrencyUnicode(566));

    return (data.length === 0) ?
        (<PageEmptyContent message='No record match your search!' />) :
        (
            <div className="view">
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                            <th>
                                    <span>S/N</span>
                                </th>
                                <th>
                                    <span>Ticket Number</span>
                                </th>
                                <th>
                                    <span>{`Tsc Charge (${nairaCurrency})`}</span>
                                </th >
                                <th>
                                    <span>{`Dispute Value (${nairaCurrency})`}</span>
                                </th>
                                <th>
                                    <span>Departure Date</span>
                                </th>
                                <th >
                                    <span>Departure Airport</span>
                                </th>
                                <th>
                                    <span>Destination Airport</span>
                                </th>
                                <th>
                                    <span>File Url</span>
                                </th>
                                <th>
                                    <span>Status</span>
                                </th>
                                <th>
                                    <span>Action</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((record, i) =>
                                <tr key={i}>
                                    <td  className="text-capitalize">{`${pageIndex + i + 1}`}</td>
                                    <td
                                        className="text-capitalize">{record.ActualTicket}</td>
                                    <td>{appHelpers.numberWithCommas(record.TSCCharge)}</td>
                                    <td>{record.DisputeValue}</td> 
                                    <td>{moment(record.DepartureDate).format('YYYY-MM-DD')}</td>
                                    <td>{`${interpretAirport(record.DepartureAirportId)}`}</td>
                                    <td>{`${interpretDesAirport(record.DestinationAirportId)}`}</td>
                                    {/* <td>{record.FileUrl}</td> */}
                                    {record.FileUrl !== null &&  record.FileUrl !== "" ?
                                    <td>
                                        <span>
                                            <a 
                                            className={'success-link'}  
                                            href={record.FileUrl}  
                                            target="_blank"
                                            download
                                             style={{color: '#00887b !important'}}> 
                                        <FileDownloadIcon size="18" color="#00887b"
                                        />&nbsp;Download
                                        </a>
                                        </span>
                                    </td> :
                                    <td>{record.FileUrl}</td>
                                    }
                                    <td>{(record.StatusName).toLowerCase() === "initiated"
                                    ?
                                    <span style={{color:"#FF6600"}}>{record.StatusName}</span>
                                    :
                                    (record.StatusName).toLowerCase() === "pending"
                                        ?
                                        <span style={{color:"#ffbf00"}}>{record.StatusName}</span>
                                        :
                                        (record.StatusName).toLowerCase() === "approved"
                                        ?
                                        <span style={{color:"#008000"}}>{record.StatusName}</span>
                                        :
                                        (record.StatusName).toLowerCase() === "rejected"
                                        ?
                                        <span style={{color:" #ff0000"}}>{record.StatusName}</span>
                                    :       
                                    <span>{record.StatusName}</span>                         }
                                </td>
                                    {(user.OrganizationType === appConstants.ORGANIZATIONS.OTHERS)  ?
                                        <td>
                                            {record.ProcessStatus === null
                                                &&
                                                <span onClick={(e) => saveToggle(e, record, "modalSlideIn")}
                                                    style={{ cursor: "pointer", color: "#ff9800", }}>
                                                    <span style={{
                                                        top: "7px",
                                                        paddingLeft: "8px",
                                                        position: "relative",
                                                        margin: "8px 0px 8px 8px",

                                                    }}><ApproveIcon /></span>Save
                                            </span>}
                                        </td> 
                                        :


                                        <td>
                                            {
                                                record.ProcessStatus === 1
                                                &&
                                                <span onClick={(e) => initiateToggle(e, record, "modalSlideIn")}
                                                    style={{ cursor: "pointer", color: "#ff9800", }}>
                                                    <span style={{
                                                        top: "7px",
                                                        paddingLeft: "8px",
                                                        position: "relative",
                                                        margin: "8px 0px 8px 8px",

                                                    }}><InitiateIcon /></span>Initiate
                                            </span>
                                            }
                                            {
                                                record.ProcessStatus === 2
                                                &&
                                                <span>
                                                    <span
                                                        onClick={(e) => approveToggle(e, record, "modalSlideIn")}
                                                        style={{ cursor: "pointer", color: "#66bb6a" }}
                                                        autoFocus
                                                    >
                                                        <span
                                                            style={{
                                                                margin: "8px 0px 8px 8px",
                                                                position: "relative",
                                                                top: "7px",
                                                                paddingLeft: "8px",
                                                            }}
                                                        >
                                                            <ApproveIcon />{" "}
                                                        </span>
                                                                    Approve
                                                         </span>
                                                    <span
                                                        onClick={(e) => rejectToggle(e, record, "modalSlideIn")}
                                                        style={{ cursor: "pointer", color: "#dd2735" }}
                                                    >
                                                        <span
                                                            style={{
                                                                margin: "8px 0px 8px 8px",
                                                                position: "relative",
                                                                top: "7px",
                                                                paddingLeft: "8px",
                                                            }}
                                                        >
                                                            <RejectIcon />{" "}
                                                        </span>
                      Reject
                    </span>
                                                </span>}
                                        </td>}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
};

class PaginatedResult extends React.Component {

    render() {
        const { converter, pageSize, currentPage, totalCount, navigate, handleApprove, approveToggle, initiateToggle, rejectToggle,
            handleReject, records, handleAirlineBD, handleDepBD, handleDesBD, handleStatusBD, saveToggle, user, interpretAirport, interpretDesAirport } = this.props;
        let pageIndex = (currentPage - 1) * pageSize;

        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-4" >
                        <ServerPaginatedTable
                            currentPage={currentPage}
                            fetchMore={navigate}
                            target={<DataTable data={records}
                                pageIndex={pageIndex}
                                converter={converter}
                                handleAirlineBD={handleAirlineBD}
                                handleDepBD={handleDepBD}
                                handleDesBD={handleDesBD}
                                handleStatusBD={handleStatusBD}
                                handleApprove={handleApprove}
                                handleReject={handleReject}
                                initiateToggle={initiateToggle}
                                approveToggle={approveToggle}
                                rejectToggle={rejectToggle}
                                saveToggle={saveToggle}
                                user={user}
                                interpretAirport={interpretAirport}
                                interpretDesAirport={interpretDesAirport}
                            />}
                            pageSize={pageSize} totalCount={totalCount}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default PaginatedResult



// WEBPACK FOOTER //
// ./src/views/dispute-log/record.js